import { APIService } from '@/service/api.js'
import urlConstant from '@/constants/uri.constants.js'
import Cookies from 'js-cookie'

/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

const state = {
  employerProfile: {},
  dashboardData: {},
  updateSettings: {},
  allPlans: {},
  employerSubscriptionData: {},
  jobApplications: {},
  contractJobApplications: {},
  empProfile: {},
  orderIdData: {},
  orderDetails: {},
  updateEmployer: {},
  footerData: {},
  checkPlanAfterLogin: {},
  fetchPostedJob: {},
  pendingJobPost: {},
  updatePendingJobPost: {},
  checkEmployeePlan: {},
  employerResumeProfile: {},
  matchResumes: {},
  savedResumes: {},
  feedbackList: {},
  submitFeedbackResponse: {},
  salesEnquiryResponse: {},
  downloadExcelResponse: {},
  fetchListOfHireEmployee: {},
  postJobDetails: {}
}

const mutations = {
  fetchProfile(state, payload) {
    switch (payload.type) {
      case 'FETCHING_PROFILE':
        state.employerProfile = {
          isFechingProfile: true,
          errorFechingProfile: false,
          responseData: {}
        }
        break
      case 'FETCHED_PROFILE':
        state.employerProfile = {
          isFechingProfile: false,
          errorFechingProfile: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchDashboardData(state, payload) {
    switch (payload.type) {
      case 'FETCHING_DASHBOARD':
        state.dashboardData = {
          isFechingDashboard: true,
          errorFechingDashboard: false,
          responseData: {}
        }
        break
      case 'FETCHED_DASHBOARD':
        state.dashboardData = {
          isFechingDashboard: false,
          errorFechingDashboard: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchAllPlans(state, payload) {
    switch (payload.type) {
      case 'FETCHING_ALL_PLANS':
        state.allPlans = {
          isFechingAllPlans: true,
          errorFechingAllPlans: false,
          responseData: {}
        }
        break
      case 'FETCHED_ALL_PLANS':
        state.allPlans = {
          isFechingAllPlans: false,
          errorFechingAllPlans: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchEmployerSubscription(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EMPLOYER_SUBSCRIPTION':
        state.employerSubscriptionData = {
          isFechingSubscription: true,
          errorFechingSubscription: false,
          responseData: {}
        }
        break
      case 'FETCHED_EMPLOYER_SUBSCRIPTION':
        state.employerSubscriptionData = {
          isFechingSubscription: false,
          errorFechingSubscription: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchJobApplications(state, payload) {
    switch (payload.type) {
      case 'FETCHING_JOB_APPLICATIONS':
        state.jobApplications = {
          isFechingJobApplications: true,
          errorFechingJobApplications: false,
          responseData: {}
        }
        break
      case 'FETCHED_JOB_APPLICATIONS':
        state.jobApplications = {
          isFechingJobApplications: false,
          errorFechingJobApplications: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchContractJobApplications(state, payload) {
    switch (payload.type) {
      case 'FETCHING_CONTRACT_JOB_APPLICATIONS':
        state.contractJobApplications = {
          isFechingContractJobApplications: true,
          errorFechingContractJobApplications: false,
          responseData: {}
        }
        break
      case 'FETCHED_CONTRACT_JOB_APPLICATIONS':
        state.contractJobApplications = {
          isFechingContractJobApplications: false,
          errorFechingContractJobApplications: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchEmployeeProfile(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EMPLOYEE_PROFILE':
        state.empProfile = {
          isFechingEmpProfile: true,
          errorFechingEmpProfile: false,
          responseData: {}
        }
        break
      case 'FETCHED_EMPLOYEE_PROFILE':
        state.empProfile = {
          isFechingEmpProfile: false,
          errorFechingEmpProfile: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchOrderId(state, payload) {
    switch (payload.type) {
      case 'FETCHING_ORDER_ID':
        state.orderIdData = {
          isFechingOrderId: true,
          errorFechingOrderId: false,
          responseData: {}
        }
        break
      case 'FETCHED_ORDER_ID':
        state.orderIdData = {
          isFechingOrderId: false,
          errorFechingOrderId: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchOrderDetails(state, payload) {
    switch (payload.type) {
      case 'FETCHING_ORDER_DETAILS':
        state.orderDetails = {
          isFechingOrderDetail: true,
          errorFechingOrderDetail: false,
          responseData: {}
        }
        break
      case 'FETCHED_ORDER_DETAILS':
        state.orderDetails = {
          isFechingOrderDetail: false,
          errorFechingOrderDetail: false,
          responseData: payload.data
        }
        break
    }
  },

  updateEmployerProfile(state, payload) {
    switch (payload.type) {
      case 'UPDATING_EMPLOYER_PROFILE':
        state.updateEmployer = {
          isUpdatingEmployer: true,
          errorUpdatingEmployer: false,
          responseData: {}
        }
        break
      case 'UPDATED_EMPLOYER_PROFILE':
        state.updateEmployer = {
          isUpdatingEmployer: false,
          errorUpdatingEmployer: false,
          responseData: payload.data
        }
        break
    }
  },

  updateProfileSettings(state, payload) {
    switch (payload.type) {
      case 'UPDATING_PROFILE_SETTINGS':
        state.updateSettings = {
          isUpdatingSettings: true,
          errorUpdatingSettings: false,
          responseData: {}
        }
        break
      case 'UPDATED_PROFILE_SETTINGS':
        state.updateSettings = {
          isUpdatingSettings: false,
          errorUpdatingSettings: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchFooter(state, payload) {
    switch (payload.type) {
      case 'FETCHING_FOOTER':
        state.footerData = {
          isFetchingFooter: true,
          errorFetchingFooter: false,
          responseData: {}
        }
        break
      case 'FETCHED_FOOTER':
        state.footerData = {
          isFetchingFooter: false,
          errorFetchingFooter: false,
          responseData: payload.data
        }
        break
    }
  },

  checkPLanAfter(state, payload) {
    switch (payload.type) {
      case 'CHECKING_PLAN_AFTER_LOGIN':
        state.checkPlanAfterLogin = {
          isCheckingPlan: true,
          errorCheckingPlan: false,
          responseData: {}
        }
        break
      case 'CHECKED_PLAN_AFTER_LOGIN':
        state.checkPlanAfterLogin = {
          isCheckingPlan: false,
          errorCheckingPlan: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchPostedJob(state, payload) {
    switch (payload.type) {
      case 'FETCHING_POSTED_JOB':
        state.fetchPostedJob = {
          isFechingJob: true,
          errorFechingJob: false,
          responseData: {}
        }
        break
      case 'FETCHED_POSTED_JOB':
        state.fetchPostedJob = {
          isFechingJob: false,
          errorFechingJob: false,
          responseData: payload.data
        }
        break
    }
  },
  pendingJob(state, payload) {
    switch (payload.type) {
      case 'POSTING_PENDING_JOB':
        state.pendingJobPost = {
          isCheckingPlan: true,
          errorCheckingPlan: false,
          responseData: {}
        }
        break
      case 'POSTED_PENDING_JOB':
        state.pendingJobPost = {
          isCheckingPlan: false,
          errorCheckingPlan: false,
          responseData: payload.data
        }
        break
    }
  },
  updatePendingJob(state, payload) {
    switch (payload.type) {
      case 'UPDATING_PENDING_JOB':
        state.updatePendingJobPost = {
          isCheckingPlan: true,
          errorCheckingPlan: false,
          responseData: {}
        }
        break
      case 'UPDATED_PENDING_JOB':
        state.updatePendingJobPost = {
          isCheckingPlan: false,
          errorCheckingPlan: false,
          responseData: payload.data
        }
        break
    }
  },
  setPostJobDetails(state, payload) {
    state.postJobDetails = payload.data
  },
  postEmployeePlan(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EMPLOYER_PROFILE':
        state.checkEmployeePlan = {
          isCheckingPlan: true,
          errorCheckingPlan: false,
          responseData: {}
        }
        break
      case 'FETCHED_EMPLOYER_PROFILE':
        state.checkEmployeePlan = {
          isCheckingPlan: false,
          errorCheckingPlan: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchEmployerProfile(state, payload) {
    switch (payload.type) {
      case 'FETCHING_EMPLOYER_PROFILE':
        state.employerResumeProfile = {
          isCheckingPlan: true,
          errorCheckingPlan: false,
          responseData: {}
        }
        break
      case 'FETCHED_EMPLOYER_PROFILE':
        state.employerResumeProfile = {
          isCheckingPlan: false,
          errorCheckingPlan: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchMatchingResumes(state, payload) {
    switch (payload.type) {
      case 'FETCHING_MATCHING_RESUMES':
        state.matchResumes = {
          isFetchingMatchingResume: true,
          errorFetchingMatchingResume: false,
          responseData: {}
        }
        break
      case 'FETCHED_MATCHING_RESUMES':
        state.matchResumes = {
          isFetchingMatchingResume: false,
          errorFetchingMatchingResume: false,
          responseData: payload.data
        }
        break
    }
  },

  fetchSavedResumes(state, payload) {
    switch (payload.type) {
      case 'FETCHING_SAVED_RESUMES':
        state.savedResumes = {
          isFetchingSavedResume: true,
          errorFetchingSavedResume: false,
          responseData: {}
        }
        break
      case 'FETCHED_SAVED_RESUMES':
        state.savedResumes = {
          isFetchingSavedResume: false,
          errorFetchingSavedResume: false,
          responseData: payload.data
        }
        break
    }
  },

  getCallback(state, payload) {
    switch (payload.type) {
      case 'GET_CALLBACK_SUCCESS':
        state.getCallback = {
          response: payload.data,
          error: false
        }
        break
      case 'GET_CALLBACK_ERROR':
        state.getCallback = {
          response: false,
          error: payload.data
        }
    }
  },

  fetchFeedbackList(state, payload) {
    switch (payload.type) {
      case 'FETCHING_FEEDBACK_LIST':
        state.feedbackList = {
          isFetchingFeedbackList: true,
          errorFetchingFeedbackList: false,
          responseData: {}
        }
        break
      case 'FETCHED_FEEDBACK_LIST':
        state.feedbackList = {
          isFetchingFeedbackList: false,
          errorFetchingFeedbackList: false,
          responseData: payload.data
        }
        break
    }
  },

  addUserFeedback(state, payload) {
    switch (payload.type) {
      case 'SUBMITTING_EMPLOYEE_FEEDBACK':
        state.submitFeedbackResponse = {
          isSubmitingFeedback: true,
          errorSubmitingFeedback: false,
          responseData: {}
        }
        break
      case 'SUBMITED_EMPLOYEE_FEEDBACK':
        state.submitFeedbackResponse = {
          isSubmitingFeedback: false,
          errorSubmitingFeedback: false,
          responseData: payload.data
        }
        break
    }
  },

  salesEnquiry(state, payload) {
    switch (payload.type) {
      case 'SUBMITTING_SALES_ENQUIRY':
        state.salesEnquiryResponse = {
          isSubmitingSalesEnquiry: true,
          errorSubmitingSalesEnquiry: false,
          responseData: {}
        }
        break
      case 'SUBMITED_SALES_ENQUIRY':
        state.salesEnquiryResponse = {
          isSubmitingSalesEnquiry: false,
          errorSubmitingSalesEnquiry: false,
          responseData: payload.data
        }
        break
    }
  },

  downloadExcel(state, payload) {
    switch (payload.type) {
      case 'DOWNLOADING_EXCEL':
        state.downloadExcelResponse = {
          isDownloadingExcel: true,
          errorDownloadingExcel: false,
          responseData: {}
        }
        break
      case 'DOWNLOADED_EXCEL':
        state.downloadExcelResponse = {
          isDownloadingExcel: false,
          errorDownloadingExcel: false,
          responseData: payload.data
        }
        break
    }
  },
  fetchListOfHireEmployee(state, payload) {
    switch (payload.type) {
      case 'FETCHING_HIRE_EMPLOYEE':
        state.fetchListOfHireEmployee = {
          isFetchingListOfHireEmployee: true,
          errorFetchingListOfHireEmployee: false,
          responseData: {}
        }
        break
      case 'FETCHED_HIRE_EMPLOYEE':
        state.fetchListOfHireEmployee = {
          isFetchingListOfHireEmployee: false,
          errorFetchingListOfHireEmployee: false,
          responseData: payload.data
        }
        break
    }
  }
}

const actions = {
  actionDownloadExcel({ commit }, _obj) {
    commit("downloadExcel", { type: "DOWNLOADING_EXCEL" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(urlConstant.baseUrl + urlConstant.downloadExcel, _obj, {
      headers: { jwt: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          // console.log("downloadExcel",commit);
          commit("downloadExcel", { type: "DOWNLOADED_EXCEL", data: res.data });
        }
      })
      .catch((err) => {
        console.log("downloadExcel", err);
      });
  },

  actionSubmitSalesEnquiry({ commit }, _obj) {
    commit("salesEnquiry", { type: "SUBMITTING_SALES_ENQUIRY" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(urlConstant.baseUrl + urlConstant.salesEnquiry, _obj, {
      headers: { jwt: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          commit("salesEnquiry", {
            type: "SUBMITED_SALES_ENQUIRY",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("salesEnquiry", err);
      });
  },

  actionAddUserFeedback({ commit }, _obj) {
    commit("addUserFeedback", { type: "SUBMITTING_EMPLOYEE_FEEDBACK" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(urlConstant.baseUrl + urlConstant.addUserFeedback, _obj, {
      headers: { jwt: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          commit("addUserFeedback", {
            type: "SUBMITED_EMPLOYEE_FEEDBACK",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("addUserFeedback", err);
      });
  },

  actionFetchFeedbackList({ commit }) {
    commit("fetchFeedbackList", { type: "FETCHING_FEEDBACK_LIST" });
    APIService.get(urlConstant.baseUrl + urlConstant.allFeedbackList)
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("fetchFeedbackList", {
            type: "FETCHED_FEEDBACK_LIST",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionCheckPlanAfterLogin({ commit }) {
    commit("checkPLanAfter", { type: "CHECKING_PLAN_AFTER_LOGIN" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(
      urlConstant.baseUrl + urlConstant.hideShowPlanAfterLogin,
      {},
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log("checkPLanAfter", res);
          commit("checkPLanAfter", {
            type: "CHECKED_PLAN_AFTER_LOGIN",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("checkPLanAfter", err);
      });
  },
  actionFetchPostedJobDetails({ commit }, jobId) {
    commit("fetchPostedJob", { type: "FETCHING_POSTED_JOB" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.get(
      urlConstant.baseUrl + urlConstant.postedJobLink + `?jobId=${jobId}`,
      {
        headers: { Authorization: jwtToken, userid: userId },
      }
    )
      .then((res) => {
        if (res.data) {
          commit("fetchPostedJob", {
            type: "FETCHED_POSTED_JOB",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchPostedJob", err);
      });
  },
  actionPendingJobPost({ commit }, _obj) {
    commit("pendingJob", { type: "POSTING_PENDING_JOB" });
    // const jwtToken = Cookies.get("authToken");
    // const userId = Cookies.get("userId");
    APIService.post(urlConstant.baseUrl + urlConstant.pendingJobPostLink, _obj)
      .then((res) => {
        if (res.data) {
          commit("pendingJob", { type: "POSTED_PENDING_JOB", data: res.data });
        }
      })
      .catch((err) => {
        console.log("pendingJob", err);
      });
  },
  actionUpdatePendingJobPost({ commit }, _obj) {
    commit("updatePendingJob", { type: "UPDATING_PENDING_JOB" });
    // const jwtToken = Cookies.get("authToken");
    // const userId = Cookies.get("userId");
    APIService.post(
      urlConstant.baseUrl + urlConstant.updatePendingJobPostLink,
      _obj
    )
      .then((res) => {
        if (res.data) {
          commit("updatePendingJob", {
            type: "UPDATED_PENDING_JOB",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("updatePendingJob", err);
      });
  },
  actionSetPostJobDetails({ commit }, _obj) {
    commit("setPostJobDetails", { type: "SET_POSTJOB_DETAILS", data: _obj });
  },
  actionGetFooter({ commit }) {
    commit("fetchFooter", { type: "FETCHING_FOOTER" });
    APIService.get(urlConstant.baseUrl + urlConstant.footer)
      .then((res) => {
        if (res.data) {
          // console.log("fetchFooter", res);
          commit("fetchFooter", { type: "FETCHED_FOOTER", data: res.data });
        }
      })
      .catch((err) => {
        console.log("fetchFooter", err);
      });
  },

  actionUpdateEmployer({ commit }, _obj) {
    commit("updateEmployerProfile", { type: "UPDATING_EMPLOYER_PROFILE" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(
      `${urlConstant.baseUrl}${urlConstant.updateEmployerProfile}`,
      _obj,
      {
        headers: { Authorization: jwtToken, userid: userId },
      }
    )
      .then((res) => {
        if (res.data) {
          // console.log("updateEmployerProfile", res);
          commit("updateEmployerProfile", {
            type: "UPDATED_EMPLOYER_PROFILE",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("updateEmployerProfile", err);
      });
  },

  actionUpdateSettings({ commit }, _obj) {
    commit("updateProfileSettings", { type: "UPDATING_PROFILE_SETTINGS" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(`${urlConstant.baseUrl}${urlConstant.settings}`, _obj, {
      headers: { Authorization: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          commit("updateProfileSettings", {
            type: "UPDATED_PROFILE_SETTINGS",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("updateProfileSettings", err);
      });
  },

  actionGetOrderDetails({ commit }, orderId) {
    commit("fetchOrderDetails", { type: "FETCHING_ORDER_DETAILS" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.get(
      urlConstant.baseUrl +
        urlConstant.fetchOrderDetails +
        "?orderId=" +
        orderId,
      {
        headers: { Authorization: jwtToken, userid: userId },
      }
    )
      .then((res) => {
        if (res.data) {
          // console.log("fetchOrderDetails Response", res);
          commit("fetchOrderDetails", {
            type: "FETCHED_ORDER_DETAILS",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchOrderDetails", err);
      });
  },

  actionGetOrderId({ commit }, _obj) {
    commit("fetchOrderId", { type: "FETCHING_ORDER_ID" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    APIService.post(urlConstant.baseUrl + urlConstant.getOrderId, _obj, {
      headers: { Authorization: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          // console.log("actionGetOrderId Response", res);
          commit("fetchOrderId", { type: "FETCHED_ORDER_ID", data: res.data });
        }
      })
      .catch((err) => {
        console.log("fetchOrderId", err);
      });
  },

  actionFetchEmployeeProfile({ commit }, _obj) {
    commit("fetchEmployeeProfile", { type: "FETCHING_EMPLOYEE_PROFILE" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(
      urlConstant.baseUrl +
        urlConstant.employeeProfile +
        "/" +
        _obj.empId +
        "/" +
        _obj.jobId +
        "/employee-profile",
      { headers: { jwt: jwtToken, userid: userId } }
    )
      // APIService.get("https://theincircle.tk/node/employer/60030d21426f7e62ca547d1d/6000692bede6ca53f092875e/employee-profile",{ headers: {"jwt" : jwtToken, userid:userId} })

      .then((res) => {
        if (res.data) {
          // console.log('nextUser', _obj);
          commit("fetchEmployeeProfile", {
            type: "FETCHED_EMPLOYEE_PROFILE",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchEmployeeProfile", err);
      });
  },

  actionFetchJobApplications({ commit }, _obj) {
    commit("fetchJobApplications", { type: "FETCHING_JOB_APPLICATIONS" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(
      `${urlConstant.baseUrl}${urlConstant.getJobApplications}?jobId=${_obj.jobId}&page=${_obj.pageNum}&perPage=${_obj.perPage}`,
      { headers: { Authorization: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("fetchJobApplications", {
            type: "FETCHED_JOB_APPLICATIONS",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionFetchContractJobApplications({ commit }, _obj) {
    commit("fetchContractJobApplications", {
      type: "FETCHING_CONTRACT_JOB_APPLICATIONS",
    });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(
      urlConstant.baseUrl +
        urlConstant.getContractJobApplications +
        "?jobId=" +
        _obj.jobId +
        "&page=" +
        _obj.pageNum,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("fetchContractJobApplications", {
            type: "FETCHED_CONTRACT_JOB_APPLICATIONS",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionFetchEmployerSubscription({ commit }) {
    commit("fetchEmployerSubscription", {
      type: "FETCHING_EMPLOYER_SUBSCRIPTION",
    });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(urlConstant.baseUrl + urlConstant.planDetails, {
      headers: { Authorization: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("fetchEmployerSubscription", {
            type: "FETCHED_EMPLOYER_SUBSCRIPTION",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },

  actionEmployerProfile({ commit }) {
    commit("fetchProfile", { type: "FETCHING_PROFILE" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(urlConstant.baseUrl + urlConstant.employerProfile, {
      headers: { Authorization: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          Cookies.set("userId", res.data.data?.employer?._id);
          var now = new Date();
          var time = now.getTime();
          var expireTime = time + 3600 * 1000 * 24 * 365 * 1;
          now.setTime(expireTime);
          Cookies.set(
            "companyName",
            res.data.data?.employer?.companyDetails?.companyName,
            {
              path: "/",
              expires: now,
            }
          );
          if (res.data.data?.employer?.companyDetails?.companyName) {
            localStorage.setItem(
              "companyName",
              res.data.data?.employer?.companyDetails?.companyName
            );
          }
          commit("fetchProfile", { type: "FETCHED_PROFILE", data: res.data });
        }
      })
      .catch((err) => {
        console.log("createTopic", err);
      });
  },
  actionDashboard({ commit }) {
    commit("fetchDashboardData", { type: "FETCHING_DASHBOARD" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    APIService.get(urlConstant.baseUrl + urlConstant.dashboard, {
      headers: { Authorization: jwtToken, userid: userId },
    })
      .then((res) => {
        if (res.data) {
          // console.log(res.data);
          commit("fetchDashboardData", {
            type: "FETCHED_DASHBOARD",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("dashboardErr", err);
      });
  },

  actionGetAllPlans({ commit }, planType) {
    commit("fetchAllPlans", { type: "FETCHING_ALL_PLANS" });
    const search = planType ? `?planType=${planType}` : "";
    APIService.get(`${urlConstant.baseUrl}${urlConstant.getAllPlan}${search}`)
      .then((res) => {
        if (res.data) {
          commit("fetchAllPlans", {
            type: "FETCHED_ALL_PLANS",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("Plans Error", err);
      });
  },

  async actionEmployeeResume({ commit }, _obj) {
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    const response = await APIService.post(
      urlConstant.baseUrl + "/paid-perks",
      _obj,
      {
        headers: {
          jwt: jwtToken,
          userid: userId,
        },
      }
    );
    return response.data;
  },

  async actionCheckEmployeePlan({ commit }) {
    commit("postEmployeePlan", { type: "POST_EMPLOYEE_PLAN" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    let resStatus = "";
    await APIService.post(
      urlConstant.baseUrl + urlConstant.checkResumeEmployee + "/",
      { userId },
      { headers: { jwt: jwtToken, userid: userId } }
    )
      .then((res) => {
        if (res.data) {
          // console.log(res);
          const { status } = res.data;
          resStatus = status;
          // console.log('ssasa', status);
          // commit("postEmployeePlan", { type: "CHECKED_POST_EMPLOYEE_PLAN", data: res.data });
        }
      })
      .catch((err) => {
        console.log("postEmployeePlan", err);
      });
    if (resStatus) {
      return resStatus;
    }
  },

  async actionFetchEmployerProfile({ commit }, _obj) {
    commit("fetchEmployerProfile", { type: "FETCHING_EMPLOYER_PROFILE" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    const empId = _obj.empid;

    await APIService.get(
      urlConstant.baseUrl +
        "/" +
        "employer" +
        "/" +
        empId +
        "/employee-details",
      { headers: { jwt: jwtToken, userid: userId } }
    )
      // APIService.get("https://theincircle.tk/node/employer/60030d21426f7e62ca547d1d/employee-details",{ headers: {"jwt" : jwtToken, userid:userId} })

      .then((res) => {
        if (res.data) {
          // console.log('employerrOBjss', res.data);
          commit("fetchEmployerProfile", {
            type: "FETCHED_EMPLOYER_PROFILE",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchEmployerProfile", err);
      });
  },

  async actionGetCallback({ commit }, data) {
    const { jobId, userId } = data;
    if (!jobId || !userId) return;
    const jwtToken = Cookies.get("authToken");
    const userStoreId = Cookies.get("userId");
    await APIService.get(
      urlConstant.baseUrl +
        `/employer/call-back?jobId=${jobId}&userId=${userId}`,
      { headers: { jwt: jwtToken, userid: userStoreId } }
    )
      .then((res) => {
        commit("getCallback", { type: "GET_CALLBACK_SUCCESS", data: res });
      })
      .catch((err) => {
        commit("getCallback", { type: "GET_CALLBACK_ERROR", data: err });
        console.log(err);
      });
  },

  async actionFetchMatchingResumes({ commit }, payLoad) {
    commit("fetchMatchingResumes", { type: "FETCHING_MATCHING_RESUMES" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    await APIService.get(
      urlConstant.baseUrl +
        urlConstant.findResumeMatching +
        "?page=" +
        payLoad.pageNum,
      { headers: { jwt: jwtToken, userid: userId } }
    )
      // APIService.get("https://theincircle.tk/node/employer/60030d21426f7e62ca547d1d/employee-details",{ headers: {"jwt" : jwtToken, userid:userId} })

      .then((res) => {
        if (res.data) {
          // console.log('employerrOBjss', res.data);
          commit("fetchMatchingResumes", {
            type: "FETCHED_MATCHING_RESUMES",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchMatchingResumes", err);
      });
  },

  async actionFetchSavedResumes({ commit }, payLoad) {
    commit("fetchSavedResumes", { type: "FETCHING_SAVED_RESUMES" });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    await APIService.get(
      urlConstant.baseUrl +
        urlConstant.savedResume +
        "?page=" +
        payLoad.pageNum,
      { headers: { jwt: jwtToken, userid: userId } }
    )

      .then((res) => {
        if (res.data) {
          commit("fetchSavedResumes", {
            type: "FETCHED_SAVED_RESUMES",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchSavedResumes", err);
      });
  },

  async fetchListOfHireEmployee({ commit }, payLoad) {
    commit("fetchListOfHireEmployee", {
      type: "FETCHING_HIRE_EMPLOYEE",
    });
    const jwtToken = Cookies.get("authToken");
    const userId = Cookies.get("userId");
    await APIService.get(
      urlConstant.baseUrl + urlConstant.getListOfHireEmployee,
      {
        headers: {
          jwt: jwtToken,
          userid: userId,
        },
      }
    )
      .then((res) => {
        if (res.data) {
          commit("fetchListOfHireEmployee", {
            type: "FETCHED_HIRE_EMPLOYEE",
            data: res.data,
          });
        }
      })
      .catch((err) => {
        console.log("fetchListOfHireEmployee", err);
      });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
